<template>
  <div id="app">
    <div class="site-content">
      <router-view/>
    </div>
  </div>
</template>

<script>

export default {
  name: "app",
  data: function() {
    return {
      secondary_active: false
    };
  }
};
</script>
